module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\r\n<div class="row">\r\n    <div class="roleSelectField col d-none">\r\n    </div>\r\n    <div class="cmbLibelle col d-none">\r\n    </div>\r\n    <div class="col input-group collabData">\r\n        <input name="searchcollab" class="searchcollab form-control" type="text" data-attributes="matricule,matriculeaux,nom,prenom" placeholder="'+
((__t=(i18n.t("common:listerecap.filtre_nom")))==null?'':__t)+
', '+
((__t=(i18n.t("common:listerecap.filtre_prenom")))==null?'':__t)+
', '+
((__t=(i18n.t("common:listerecap.filtre_matricule")))==null?'':__t)+
'">\r\n        <div class="loupe input-group-append cw-texteTresAllege">\r\n            <label class="input-group-text">'+
((__t=(icon))==null?'':__t)+
'</label>\r\n        </div>\r\n    </div>\r\n</div>\r\n';
}
return __p;
};
